import { render, staticRenderFns } from "./MeetConcluding.vue?vue&type=template&id=64f70713&scoped=true"
import script from "./MeetConcluding.vue?vue&type=script&lang=js"
export * from "./MeetConcluding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f70713",
  null
  
)

export default component.exports